<template>
  <div
    v-if="author"
    class="Author"
  >
    <div class="back">
      <div>
        <a href="/">{{ $t('BUTTON.BACK') }}</a>

        <span class="name">{{ author.Nombre }} {{ author.Apellidos }}</span>

        <span
          v-for="disciplina in author.userdatas"
          :key="disciplina.id"
          class="categoryHead"
        >{{ $t('DISCIPLINE.'+ disciplina.disciplina.txt.toUpperCase()) }}</span>
      </div>
    </div>
    <div class="main">
      <div class="content">
        <div class="author-info">
          <img
            class="avatar"
            :src="loadImageServer(author.image, 0)"
            alt=""
          >

          <p>{{ author.Nombre }} {{ author.Apellidos }}</p>
          <p>{{ $t('TERRITORY.'+ author.Territorio.txt.toUpperCase()) }}</p>
          <p
            v-for="disciplina in author.userdatas"
            :key="disciplina.id"
            class="category"
          >
            {{ $t('DISCIPLINE.'+ disciplina.disciplina.txt.toUpperCase()) }}
          </p>
        </div>
        <div class="author-image">
          <h2 class="title">
            {{ $t('DISCIPLINE.'+ author.userdatas[slide].disciplina.txt.toUpperCase()) }}
          </h2>
          <div class="slider-button">
            <button
              class="btn prev"
              @click="prev"
            >
              {{ $t('BUTTON.LAST') }}
            </button>

            <button
              class="btn next"
              @click="next"
            >
              {{ $t('BUTTON.NEXT') }}
            </button>
          </div>

          <div class="carousel-wrapper">
            <div class="carousel">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="0"
                no-animation
                background="black"
              >
                <b-carousel-slide
                  :img-src="loadImageServer(author.userdatas[slide].image, 1)"
                />
              </b-carousel>
            </div>
          </div>
        </div>
        <div
          v-if="!currentDiscipline"
          class="author-image"
        >
          <h2 class="title">
            {{ $t('DISCIPLINEVIEW.NONE') }}
          </h2>
          <div class="carousel-wrapper">
            <div class="carousel">
              <img
                src="@/assets/images/paints/noImagen2.jpg"
                alt=""
              >
            </div>
          </div>
        </div>
        <div class="author-description">
          <h2 class="title">
            {{ $t('AUTHOR.DESCRIPTION') }}
          </h2>

          <p class="description">
            {{ author.userdatas[slide].descripcion }}
          </p>
        </div>
        <div
          v-if="!currentDiscipline"
          class="author-description"
        >
          <h2 class="title">
            {{ $t('AUTHOR.NODESCRIPTION') }}
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <BaseLoader />
  </div>
</template>

<script>

import { get } from 'vuex-pathify';

export default {
  data() {
    return {
      author: undefined,
      slide: 0,
    };
  },

  computed: {
    ...get('authorsModule', ['getAuthor']),

    currentDiscipline() {
      return this.author.userdatas[this.slide];
    },
  },

  async created() {
    // calls to store action
    const { authorId } = this.$route.params;
    await this.$store.dispatch('authorsModule/fetchAuthor', authorId);
    this.author = this.getAuthor();
  },

  methods: {
    prev() {
      if (this.slide > 0) {
        this.slide = this.slide - 1;
      }
      return this.slide;
    },

    next() {
      if (this.slide < this.author.userdatas.length - 1) {
        this.slide = this.slide + 1;
      }
      if (this.slide === this.author.userdatas.length) {
        this.slide = 0;
      }
      return this.slide;
    },

    loadImageServer(image, number) {
      if (number === 1) {
        if (image) {
          return `${process.env.VUE_APP_BASE_URL}/uploads/images/${image}`;
        }

        // eslint-disable-next-line global-require
        return `${require('@/assets/images/paints/noImagen2.jpg')}`;
      }
      return `${process.env.VUE_APP_BASE_URL}/uploads/images/${image}`;
    },
  },
};
</script>

<style lang="scss" scope>
.Author {
  display: grid;
  grid-template-rows: auto 1fr;
  position: relative;

  .back {
    background-color: black;
    > div {
      max-width: 1440px;
      margin: 0 auto;
    }

    a {
      color: white;
      background-color: var(--color-primary);
      display: inline-block;
      padding: 0.5rem;
      width: 120px;
      text-decoration: none;
      text-transform: uppercase;
      font-size: 1.1rem;
      &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-left: solid 2px white;
        border-bottom: solid 2px white;
        transform: rotate(45deg) translateY(-3px);
        margin-right: 5px;
      }
    }
    span {
      color: white;
      margin-left: 0.8rem;
      text-transform: uppercase;
      padding: 0.5rem 0;
      display: inline-block;
      &.name::after {
        content: '/';
        margin-left: 0.8rem;
      }
    }
  }
  .main {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
    .content {
      display: flex;
      gap: 2rem;
      flex-wrap: wrap;
      height: 100%;
      @media #{$breakpoint-md-max} {
        display: grid;
        grid-template-columns: 100%;
      }
      .author-info {
        margin-left: 120px;
        background: var(--color-primary-light);
        padding: 2rem;
        text-align: center;
        flex: 0 0 270px;
        @media #{$breakpoint-md-max} {
          margin-left: 0;
        }
        .avatar {
          border-radius: 50%;
          width: 120px;
          margin-bottom: 1rem;
        }
        p {
          color: white;
          margin: 0.5rem;
          &.category {
            color: black;
          }
        }
      }
      .author-image {
        flex: 1 0 250px;
        padding: 0 1rem;
        .carousel-wrapper {
          display: flex;
          margin-top: 2rem;
        }
        .slider-button {
          background: #f0f0f0;
          text-align: center;
          margin-bottom: 1rem;
          .btn {
            padding: 0 0;
            color: #212529;
            margin-left: 10px;
            border-radius: 10px;
            height: 35px;
            font-size: 15px;
            &.prev {
              background: url('~@/assets/images/icons/arrow-left.svg') no-repeat left center;
              padding-left: 1.5rem;
            }
            &.next {
              background: url('~@/assets/images/icons/arrow-right.svg') no-repeat right center;
              padding-right: 1.5rem;
            }
            &:hover {
              color: black;
            }
            &:focus {
              box-shadow: none;
            }
          }
        }
      }
      .author-description {
        flex: 3;
        padding: 0 1rem;
      }
      .slider-button {
        background: #f0f0f0;
        text-align: center;
        margin-bottom: 1rem;
        .btn {
          padding: 0 0;
          color: #212529;
          margin-left: 10px;
          border-radius: 10px;
          height: 35px;
          font-size: 15px;
          &.prev {
            background: url('~@/assets/images/icons/arrow-left.svg') no-repeat left center;
            padding-left: 1.5rem;
          }
          &.next {
            background: url('~@/assets/images/icons/arrow-right.svg') no-repeat right center;
            padding-right: 1.5rem;
          }
          &:hover {
            color: black;
          }
          &:focus {
            box-shadow: none;
          }
        }
      }
      .title {
        font-size: 2rem;
        position: relative;
        margin: 2rem 0;
        color: black;
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          bottom: -0.5rem;
          width: 100px;
          height: 3px;
          background-color: var(--color-primary);
        }
      }
      .description {
        color: rgb(94, 93, 93);
      }
    }
  }
}
</style>
